module.exports = __webpack_public_path__ + "img/light.9ce0b5b0.png";